import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

const CustomSwitch = ({
  label,
  name,
  checked,
  onChange,
  labelPlacement = "end",
}) => {
  return (
    <FormControlLabel
      control={<Switch name={name} checked={checked} onChange={onChange} />}
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default CustomSwitch;
